// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Proportional symbol and pie styles */

/*   muted country boundaries */
.em--ps .em-cntbn {
    stroke: grey;
}

/*   muted nuts boundaries */
.em--ps .em-bn-1,
.em--ps .em-bn-2,
.em--ps .em-bn-3,
.em--ps .em-nutsrg [lvl='3'],
.em--ps .em-nutsrg [lvl='2'],
.em--ps .em-nutsrg [lvl='1'],
.em--ps .em-bn-co {
    stroke-width: 0.07px;
}

/*  muted country fill */
.em--ps .em-cntrg {
    fill: #f2f2f2;
}

/*  regions without data input */
.em--ps [ecl='ni'] {
    fill: #f2f2f2;
}

/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */
/* .em--ps g#em-cntbn>.em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {
    stroke-width: 0px;
} */

/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */
.em--ps .em-bn-co {
    stroke: grey;
    stroke-width: 0.2px;
}
`, "",{"version":3,"sources":["webpack://./src/css/layers/proportional-symbol.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC,+BAA+B;AAC/B;IACI,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;;;;;;;IAOI,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI,aAAa;AACjB;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA,uHAAuH;AACvH;;GAEG;;AAEH,0HAA0H;AAC1H;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["/* Proportional symbol and pie styles */\r\n\r\n/*   muted country boundaries */\r\n.em--ps .em-cntbn {\r\n    stroke: grey;\r\n}\r\n\r\n/*   muted nuts boundaries */\r\n.em--ps .em-bn-1,\r\n.em--ps .em-bn-2,\r\n.em--ps .em-bn-3,\r\n.em--ps .em-nutsrg [lvl='3'],\r\n.em--ps .em-nutsrg [lvl='2'],\r\n.em--ps .em-nutsrg [lvl='1'],\r\n.em--ps .em-bn-co {\r\n    stroke-width: 0.07px;\r\n}\r\n\r\n/*  muted country fill */\r\n.em--ps .em-cntrg {\r\n    fill: #f2f2f2;\r\n}\r\n\r\n/*  regions without data input */\r\n.em--ps [ecl='ni'] {\r\n    fill: #f2f2f2;\r\n}\r\n\r\n/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */\r\n/* .em--ps g#em-cntbn>.em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {\r\n    stroke-width: 0px;\r\n} */\r\n\r\n/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */\r\n.em--ps .em-bn-co {\r\n    stroke: grey;\r\n    stroke-width: 0.2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
